import { useCallback, useMemo, useState } from "react";
import "./index.css";

import { AboutScreen } from "./components/AboutScreen";
import { GalleryScreen } from "./components/GalleryScreen";
import { HomeScreen } from "./components/HomeScreen";
import { LockScreen } from "./components/LockScreen";
import { PhoneShell } from "./components/PhoneShell";
import { StoryViewer } from "./components/StoryViewer";
import { categories, type VideoCategory } from "./content";

type Route = "lock" | "home" | "about" | "gallery";

export function App() {
  const [route, setRoute] = useState<Route>("lock");
  const [storyCategory, setStoryCategory] = useState<VideoCategory | null>(null);

  const cats = useMemo(() => categories, []);

  const goHome = useCallback(() => setRoute("home"), []);
  const [storySessions, setStorySessions] = useState(0);
  const openStory = useCallback((c: VideoCategory) => {
    setStorySessions(n => n + 1);
    setStoryCategory(c);
  }, []);
  const closeStory = useCallback(() => setStoryCategory(null), []);

  return (
    <PhoneShell>
      {storyCategory ? (
        <StoryViewer
          category={storyCategory}
          onClose={closeStory}
          showNavHintOnOpen={storySessions === 1}
        />
      ) : (
        <>
          <StatusBar />
          {route === "lock" ? <LockScreen onUnlock={() => setRoute("home")} /> : null}
          {route === "home" ? <HomeScreen onOpenApp={id => setRoute(id)} /> : null}
          {route === "about" ? <AboutScreen onClose={goHome} /> : null}
          {route === "gallery" ? (
            <GalleryScreen categories={cats} onClose={goHome} onOpenCategory={openStory} />
          ) : null}
        </>
      )}
    </PhoneShell>
  );
}

function StatusBar() {
  const t = new Date().toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <div className="status-bar" aria-hidden>
      <span className="status-time">{t}</span>
      <span className="status-icons">
        <span className="status-signal" />
        <span className="status-wifi" />
        <span className="status-battery" />
      </span>
    </div>
  );
}

export default App;
